
  // import qdapHomePageQuery from '@/apollo/queries/qdap/qdapHomePage';
  import pageMeta from '~/mixins/pageMeta.js';
  import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
  import eventTrackingQdapMallFnMixins from '~/mixins/eventTrackingQdapMallFnMixins.js';

  export default {
    name: 'IndexPage',
    
    mixins: [pageMeta, eventTrackingMixins, eventTrackingQdapMallFnMixins],

    data() {
      return {
        homepage: Object,
        loading: 0,
        pageData: null,
      };
    },

    
    
  head() {
    if (this.$i18n.locale === 'en') {
      return {
        meta: [
          {
            hid: 'robots',
            name: 'robots',
            content: 'noindex',
          },
        ]
      }
    }
  },
  
    mounted() {
      this.setEventTrackingListenersForQdapMall()
    },

  };
  